import {RootState} from 'app/rootReducer';

import {createSelector} from '@reduxjs/toolkit';

import {DigitalPracticeState} from './digitalPracticeSlice';

function getDigitalPractice(state: RootState): DigitalPracticeState {
  return state.digitalPractice;
}

export const selectStripeConnectStatus = createSelector(
  getDigitalPractice,
  dp => dp.stripeConnect.status,
);

export const selectWellbitCashingHistory = createSelector(
  getDigitalPractice,
  dp => dp.collaboration.cashingHistory,
);

export const selectCollaborationStatus = createSelector(
  getDigitalPractice,
  dp => dp.collaboration.status,
);

export const selectWellbitBalanceHistory = createSelector(
  getDigitalPractice,
  dp => dp.wellbits.totalWellbits,
);

export const selectWellbitStatus = createSelector(
  getDigitalPractice,
  dp => dp.wellbits.status,
);

export const selectSouthAfricanBankListStatus = createSelector(
  getDigitalPractice,
  dp => dp.southAfricanBankList.status,
);

export const selectSouthAfricanBankList = createSelector(
  getDigitalPractice,
  dp => dp.southAfricanBankList.data,
);
